export const { VITE_APP_ENV: APP_ENV = "local" } = import.meta.env;
